import { createContext } from 'react';

import type { FormReadOnlyContextValue } from './types';

export const FormReadOnlyContext = createContext<FormReadOnlyContextValue>({
  readOnly: false,
  showValidationErrors: false,
});
